import React from "react";

// TODO: sitebuild
export const Page404 = () => {
    return <>404</>;
};
